var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal fade", attrs: { id: _vm.modalId } }, [
    _c(
      "div",
      {
        staticClass: "modal-dialog modal-dialog-scrollable modal-xs",
        attrs: { role: "document" }
      },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.board.name + " - " + _vm.$t("txtSharedWith")) +
                "\n                "
            ),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close.apply(null, arguments)
                  }
                }
              },
              [_vm._v("×")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter,
                      expression: "filter"
                    }
                  ],
                  staticClass: "form-control mb-3",
                  attrs: { placeholder: _vm.$t("txtSearch") },
                  domProps: { value: _vm.filter },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.filter = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _c("div", [
                  _c("b", [_vm._v(" " + _vm._s(_vm.$t("txtSharedWith")) + " ")])
                ]),
                _vm._v(" "),
                _vm.alreadySharedWithFiltered.length
                  ? _c(
                      "ul",
                      { staticClass: "list-group w-100" },
                      _vm._l(_vm.alreadySharedWithFiltered, function(user) {
                        return _c(
                          "li",
                          {
                            key: user.id,
                            staticClass: "list-group-item ptr p-1 px-2",
                            on: {
                              click: function($event) {
                                return _vm.remove(user)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(user.firstName + " " + user.lastName) +
                                "\n                            "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm.alreadySharedWith.length
                  ? _c("div", [
                      _vm._v(
                        " " + _vm._s("(" + _vm.$t("generalNothingToShow") + ")")
                      )
                    ])
                  : _c("div", [
                      _vm._v(" " + _vm._s("(" + _vm.$t("generalNobody") + ")"))
                    ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6" }, [
                _c("div", [_c("b", [_vm._v(_vm._s(_vm.$t("txtAvailable")))])]),
                _vm._v(" "),
                _vm.availableFiltered.length
                  ? _c(
                      "ul",
                      { staticClass: "list-group w-100" },
                      _vm._l(_vm.availableFiltered, function(user) {
                        return _c(
                          "li",
                          {
                            key: user.id,
                            staticClass: "list-group-item ptr p-1 px-2",
                            on: {
                              click: function($event) {
                                return _vm.add(user)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(user.firstName + " " + user.lastName) +
                                "\n                            "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm.available.length
                  ? _c("div", [
                      _vm._v(
                        " " + _vm._s("(" + _vm.$t("generalNothingToShow") + ")")
                      )
                    ])
                  : _c("div", [
                      _vm._v(" " + _vm._s("(" + _vm.$t("generalNobody") + ")"))
                    ])
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }